import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clone from 'ramda/src/clone';
import filter from 'ramda/src/filter';
import findIndex from 'ramda/src/findIndex';
import isNil from 'ramda/src/isNil';
import length from 'ramda/src/length';
import move from 'ramda/src/move';
import propEq from 'ramda/src/propEq';
import remove from 'ramda/src/remove';
import CheckIcon from '@components/@core/CheckIcon';
import Dropdown from '@components/@core/Dropdown';
import Input from '@components/@core/Input';
import Pagination from '@components/@core/Pagination';
import EditDropdown from '@components/EditDropdown';
import { QuotaRequirement } from '~/services/config';
import { inPage } from '~/services/util';

class QuotasEdit extends Component {
    state = { current: 1, per: 5 };

    handleCalculation = (type, item) => (e) => {
        let _item = clone(item);
        let data = {};
        const calc = e[0];
        if (type === 'calculation') {
            data = this.props.data.map((m) => {
                if (m.id == _item.id) {
                    _item.quota_calculation = calc.value;
                    return _item;
                }
                return m;
            });
        } else if (type === 'month') {
            data = this.props.data.map((m) => {
                if (m.id == _item.id) {
                    _item.span_months = calc.value;
                    _item.minimum_months = calc.value;
                    return _item;
                }
                return m;
            });
        } else if (type === 'requirement') {
            data = this.props.data.map((m) => {
                if (m.id == _item.id) {
                    return _item;
                }
                return m;
            });
        }

        this.props.onChange(data);
    };

    handleSelectMenu = (item) => (e) => {
        const index = findIndex(propEq('id', item.id), this.props.data);
        let data = clone(this.props.data);
        switch (e) {
            case 'move up':
                data = move(index, index - 1, data);
                break;
            case 'move down':
                data = move(index, index + 1, data);
                break;
            case 'remove':
                data = remove(index, 1, data);
                break;
            default:
                break;
        }
        this.props.onChange(data);
    };

    handleTarget = (item) => (e) => {
        const quota_target = Number(e);
        const data = this.props.data.map((m) => {
            if (m.id === item.id) {
                item.quota_target = quota_target;
                return item;
            }
            return m;
        });
        this.props.onChange(data);
    };

    render() {
        const { current, per } = this.state;
        const { data, options, type } = this.props;
        const months = [...Array(12).keys()].map((key) => ({
            id: key + 1,
            value: key + 1,
            label: `${key + 1}`,
        }));

        return (
            <div className="career-required-instances">
                <div className="quotas">
                    <div className="list d-none d-sm-flex">
                        <div className="d-flex-7">
                            <span className="dsl-m12">Achievement</span>
                        </div>
                        {type === 'instance' && (
                            <div className="d-flex d-flex-11">
                                <div className="d-flex-5 px-0">
                                    <p className="dsl-d12">Calculation</p>
                                </div>
                                <div className="d-flex-2  px-0">
                                    <p className="dsl-d12">Months</p>
                                </div>
                                <div className="d-flex-3 px-0">
                                    <p className="dsl-d12">Requirement</p>
                                </div>
                                <div className="d-flex-2 px-0">
                                    <p className="dsl-d12">Required</p>
                                </div>
                            </div>
                        )}
                        <div className="edit" />
                    </div>
                    {data.map((item, index) => {
                        let dotsMenu = ['Move Down', 'Move Up', 'Remove'];
                        if (index === 0) {
                            dotsMenu = filter((x) => !(x === 'Move Up'), dotsMenu);
                        }
                        if (index + 1 === length(data)) {
                            dotsMenu = filter((x) => !(x === 'Move Down'), dotsMenu);
                        }
                        return (
                            inPage(index, current, per) && (
                                <div className="list d-flex ssm-column" key={`qt-${index}`}>
                                    <div className="d-flex d-flex-7">
                                        <CheckIcon className="my-auto" size={26} checked={!isNil(item.completed_at)} />
                                        <div className="ml-4 flex-grow-1">
                                            <p className="dsl-b14 text-400 mb-1">{item.name || item.data.name}</p>
                                            <p className="dsl-m12 mb-0">{item.description || item.data.description}</p>
                                        </div>
                                        <EditDropdown className="mobile-screen" options={dotsMenu} onChange={this.handleSelectMenu(item)} />
                                    </div>
                                    {type === 'instance' && (
                                        <div className="d-flex ssm-column d-flex-11">
                                            <div className="d-flex-5 d-h-start dropdown-wrap">
                                                <label className="dsl-b14 mb-0 mobile-screen w-40">Calculation</label>
                                                <Dropdown
                                                    className="calculation-dropdown"
                                                    placeholder="Select"
                                                    returnBy="data"
                                                    width="100%"
                                                    defaultIds={[item.quota_calculation]}
                                                    data={options}
                                                    getValue={(e) => e['label']}
                                                    onChange={this.handleCalculation('calculation', item)}
                                                />
                                            </div>
                                            <div className="d-flex-2 d-h-start px-0">
                                                <label className="dsl-b14 mb-0 mobile-screen w-40">Months</label>
                                                {item.quota_calculation === 3 && (
                                                    <Dropdown
                                                        placeholder="Select"
                                                        width="fit-content"
                                                        returnBy="data"
                                                        defaultIds={[item.span_months]}
                                                        data={months}
                                                        getValue={(e) => e['label']}
                                                        onChange={this.handleCalculation('month', item)}
                                                    />
                                                )}
                                            </div>
                                            <div className="d-flex-3 d-h-start px-0">
                                                <label className="dsl-b14 mb-0 mobile-screen w-40">Requirements</label>
                                                <Dropdown
                                                    placeholder="Select"
                                                    width="fit-content"
                                                    returnBy="data"
                                                    defaultIds={[item.quota_direction]}
                                                    data={QuotaRequirement}
                                                    getValue={(e) => e['name']}
                                                    onChange={this.handleCalculation('requirement', item)}
                                                />
                                            </div>
                                            <div className="d-flex-2 d-h-start">
                                                <label className="dsl-b14 mb-0 mobile-screen w-60">Required</label>
                                                <Input type="number" placeholder="Type required number here..." value={item.quota_target || 0} onChange={this.handleTarget(item)} />
                                            </div>
                                        </div>
                                    )}
                                    <div className="edit desktop-flex">
                                        <EditDropdown options={dotsMenu} onChange={this.handleSelectMenu(item)} />
                                    </div>
                                </div>
                            )
                        );
                    })}
                </div>
                <Pagination
                    current={current}
                    per={per}
                    pers={[5, 10, 'all']}
                    total={Math.ceil(data.length / per)}
                    onPer={(e) => this.setState({ per: e })}
                    onChange={(e) => this.setState({ current: e })}
                />
            </div>
        );
    }
}

QuotasEdit.propTypes = {
    data: PropTypes.array,
    type: PropTypes.oneOf(['instance', 'template']),
};

QuotasEdit.defaultProps = {
    data: [],
    type: 'instance',
};

export default QuotasEdit;
